import { SearchContext } from '@context/search.context';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { useContextSelector } from 'use-context-selector';
import { BrandSearchResult } from '@interfaces/api/responses/brand-search-response';
import SearchBarList from '@components/atoms/search-bar/components/search-bar-list';
import styles from '../filters.module.scss';

interface SearchBarSuggestionsProps {
  queryResults: BrandSearchResult[];
  contentId: ContentIds;
  onSubmit: (text?: string) => Promise<void>;
}

export enum ContentIds {
  ProductSuggestion = 'suggestion product',
  BrandSuggestion = 'suggestion brand',
}

const LABELS = {
  [ContentIds.ProductSuggestion]: 'SEARCH.SUGGESTIONS.ALL_THE_RESULTS',
  [ContentIds.BrandSuggestion]: 'SEARCH.SUGGESTIONS.BRANDS',
};

const SearchBarSuggestions: React.FC<SearchBarSuggestionsProps> = (props) => {
  const { queryResults, contentId, onSubmit } = props;

  const { t } = useTranslation('default-layout');
  const searchQuery = useContextSelector(SearchContext, (v) => v.searchQuery);
  const setSearchQuery = useContextSelector(SearchContext, (v) => v.setSearchQuery);

  const onClick = (keyword: string) => {
    setSearchQuery(keyword);
    onSubmit(keyword);
  };

  const label = t(
    LABELS[contentId],
    contentId === ContentIds.ProductSuggestion && {
      searchValue: searchQuery,
    },
  );

  return (
    <SearchBarList label={label}>
      {queryResults.length > 0 &&
        queryResults.map((resultItem: BrandSearchResult) => (
          <li
            key={resultItem.name}
            className={styles.searchListItem}
          >
            <button onClick={() => onClick(resultItem.name)}>{resultItem.name}</button>
          </li>
        ))}
    </SearchBarList>
  );
};

export default SearchBarSuggestions;
